import {
  CLEAR_APPLICATIONS,
  CREATE_APPLICATION,
  DELETE_APPLICATION,
  FETCH_AFFILIATE_LINK,
  FETCH_ALL_APPLICATIONS,
  FETCH_APPLICATIONS,
  FETCH_REVIEWS,
  LISTEN_TO_APPLICATION_PHOTOS,
  LISTEN_TO_SELECTED_APPLICATION,
  SET_LANGUAGE,
  SET_LEVEL,
  SET_MEDIA_TYPE,
  SET_SHOW_GENERIC,
  UPDATE_APPLICATION,
} from './libraryConstants';
import {
  asyncActionError,
  asyncActionFinish,
  asyncActionStart,
} from '../../app/async/asyncReducer';
import {
  dataFromSnapshot,
  fetchAllApplicationsFromFirestore,
  fetchAllBrokenLinksFromFirestore,
  fetchApplicationsFromFirestore,
  getAffiliateURLFromSlug,
  getApplicationBySlug,
  getReviewsByApplicationId,
} from '../../app/firestore/firestoreService';

export function fetchAffiliateLink(slug) {
  if (!slug) return;
  return async function (dispatch) {
    dispatch(asyncActionStart());
    try {
      const snapshot = await getAffiliateURLFromSlug(slug).get();
      const application = snapshot.docs.map((doc) => dataFromSnapshot(doc));
      if (application && application[0]) {
        const affiliate_link = application[0]['affiliate_link'];
        dispatch({
          type: FETCH_AFFILIATE_LINK,
          payload: affiliate_link,
        });
      } else {
        dispatch(
          asyncActionError({
            code: 'not-found',
            message: "Sorry, I didn't find anything",
          })
        );
      }
      dispatch(asyncActionFinish());
      return;
    } catch (error) {
      console.log({ error });
      dispatch(asyncActionError(error));
    }
  };
}

export function listenToApplications(applications) {
  return {
    type: FETCH_APPLICATIONS,
    payload: applications,
  };
}

export function createApplication(application) {
  return {
    type: CREATE_APPLICATION,
    payload: application,
  };
}
export function updateApplication(application) {
  return {
    type: UPDATE_APPLICATION,
    payload: application,
  };
}
export function deleteApplication(applicationId) {
  return {
    type: DELETE_APPLICATION,
    payload: applicationId,
  };
}

export function fetchReviewsByAppId(appId) {
  return async function (dispatch) {
    dispatch(asyncActionStart());
    try {
      const snapshot = await getReviewsByApplicationId(appId).get();
      const reviews = snapshot.docs.map((doc) => dataFromSnapshot(doc));
      // console.log({ appID: appId, reviews });
      dispatch({
        type: FETCH_REVIEWS,
        payload: reviews,
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError(error));
    }
  };
}

export function fetchApplicationBySlug(slug) {
  return async function (dispatch) {
    dispatch(asyncActionStart());
    try {
      const snapshot = await getApplicationBySlug(slug).get();
      const application = snapshot.docs.map((doc) => dataFromSnapshot(doc));

      application && application[0]
        ? dispatch({
            type: LISTEN_TO_SELECTED_APPLICATION,
            payload: application[0],
          })
        : dispatch(
            asyncActionError({
              code: 'not-found',
              message: "Sorry, I didn't find anything",
            })
          );
      dispatch(asyncActionFinish());
      return;
    } catch (error) {
      dispatch(asyncActionError(error));
    }
  };
}

export function fetchApplications(
  language,
  level,
  media_type,
  limit,
  lastDocSnapshot,
  showGeneric
) {
  return async function (dispatch) {
    dispatch(asyncActionStart());
    try {
      const snapshot = await fetchApplicationsFromFirestore(
        language,
        level,
        media_type,
        limit,
        lastDocSnapshot,
        showGeneric
      ).get();
      const lastVisible = snapshot.docs[snapshot.docs.length - 1];
      const moreApplications = snapshot.docs.length >= limit;
      const applications = snapshot.docs.map((doc) => dataFromSnapshot(doc));
      dispatch({
        type: FETCH_APPLICATIONS,
        payload: { applications, moreApplications, lastVisible },
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError(error));
    }
  };
}

export function setLanguage(value) {
  return function (dispatch) {
    dispatch(clearApplications());
    dispatch({ type: SET_LANGUAGE, payload: value });
  };
}

export function setShowGeneric(value) {
  return function (dispatch) {
    dispatch(clearApplications());
    dispatch({ type: SET_SHOW_GENERIC, payload: value });
  };
}

export function setLevel(value) {
  return function (dispatch) {
    dispatch(clearApplications());
    dispatch({ type: SET_LEVEL, payload: value });
  };
}
export function setMediaType(value) {
  return function (dispatch) {
    dispatch(clearApplications());
    dispatch({ type: SET_MEDIA_TYPE, payload: value });
  };
}

export function fetchAllApplications() {
  return async function (dispatch) {
    dispatch(asyncActionStart());
    try {
      const snapshot = await fetchAllApplicationsFromFirestore().get();
      const applications = snapshot.docs.map((doc) => dataFromSnapshot(doc));
      dispatch({
        type: FETCH_ALL_APPLICATIONS,
        payload: applications,
      });
    } catch (error) {
      dispatch(asyncActionError(error));
    } finally {
      dispatch(asyncActionFinish());
    }
  };
}

export function fetchAllBrokenLinks() {
  return async function (dispatch) {
    dispatch(asyncActionStart());
    try {
      const snapshot = await fetchAllBrokenLinksFromFirestore().get();
      const applications = snapshot.docs.map((doc) => dataFromSnapshot(doc));
      dispatch({
        type: FETCH_ALL_APPLICATIONS,
        payload: applications,
      });
    } catch (error) {
      dispatch(asyncActionError(error));
    } finally {
      dispatch(asyncActionFinish());
    }
  };
}

export function listenToApplicationPhotos(photos) {
  return {
    type: LISTEN_TO_APPLICATION_PHOTOS,
    payload: photos,
  };
}

export function listenToSelectedApplication(application) {
  //console.log(application);
  return {
    type: LISTEN_TO_SELECTED_APPLICATION,
    payload: application,
  };
}

export function clearApplications() {
  return {
    type: CLEAR_APPLICATIONS,
  };
}
